// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isNetworkError(error: any) {
  try {
    const msg = (error as Error).message.toLowerCase();

    return (
      msg.includes('failed to fetch') || // chrome/edge
      msg.includes('networkerror') || // firefox
      msg.includes('network error') || // sanity check with and without spae
      msg.includes('resource blocked') || // safari
      error.name === 'AbortError'
    );
  } catch (e) {
    return false;
  }
}

export function isOnline() {
  return window.navigator.onLine;
}
